// packages block
import Lottie from "lottie-react";
import { useHistory } from "react-router";
import ReactDropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Dialog, Button, Typography } from "@material-ui/core";
import ReportIcon from "@material-ui/icons/Report";
import { useDispatch, useSelector } from "react-redux";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormButton } from "../form/button";
import { PreDialogHeader } from "./preDialogHeader";
// constants, theme, utils and api block
import { ADDCSVSTUDENTSNOTES } from "../../util/constants";
import { setAlert } from "../../redux/reducers/alert";
//import csvStd from "../../assets/csv/std.csv";
import csvStd from "../../assets/csv/bulk-parent.csv";
import { BLUE_EIGHT, WHITE } from "../../theme";
import csvInvoice from "../../assets/csv/invoice.csv";
import csvBalance from "../../assets/csv/bulk-parent.csv";
import addBulkStudentIconAnimation from "../../assets/video/add-bulk-student-icon-animation.json";

export const PreUpdateDialog = ({
  open,
  handleClose,
  title,
  multipleTitle = "Add Multiple Schools",
  generateInvoice = false,
  handleFileUpload = () => {},
  backbut = false,
  url = undefined,
}) => {
  const classes = preaddStyles();
  const { role } = useSelector((state) => state.user);
  const [genInvoice, setGenInvoice] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  const history = useHistory();

  const [file, setFile] = useState(null);

  const uploadFile = (acceptedFiles) => {
    let fileSize = acceptedFiles[0].size / 1024 / 1024;
    if (fileSize < 10) {
      if (acceptedFiles.length > 0) setFile(acceptedFiles[0]);
    } else {
      showErrorAlert(
        t("text_your_csv_must_be_10MB_or_greater_than_10MB_try_again")
      );
    }
  };

  const handleUpload = async () => {
    if (file.type === "application/vnd.ms-excel") {
      handleFileUpload(file);
      history.push("/students");
    } else {
      handleFileUpload(file);
      history.push("/students");
    }
  };

  useEffect(() => {
    if (!open) setFile(null);
  }, [open]);

  useEffect(() => {
    setGenInvoice(generateInvoice);
  }, [generateInvoice]);

  const close = () => {
    setFile(null);
    handleClose();
  };

  return (
    <Dialog
      className={classes.root}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader title={title} handleClose={close} backbut={backbut} />
        <div className={classes.dropContainer}>
          {!genInvoice && (
            <PreDialogOption list={ADDCSVSTUDENTSNOTES} title={multipleTitle}>
              <div className={classes.csvDropZoneContainer}>
                <ReactDropzone onDrop={uploadFile} multiple={false}>
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div {...getRootProps()}>
                        <input {...getInputProps()} accept=".csv" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className={classes.csvDetail}>
                            <Lottie
                              animationData={addBulkStudentIconAnimation}
                              style={{ width: 150 }}
                              loop={true}
                            />
                            {!file && (
                              <div
                                style={{
                                  cursor: "pointer",
                                  borderRadius: 15,
                                  textTransform: "none",
                                  fontSize: "0.8vw",
                                  fontWeight: "700",
                                  borderColor: BLUE_EIGHT,
                                  color: BLUE_EIGHT,
                                  backgroundColor: WHITE,
                                  height: 40,
                                  width: "10vw",
                                  border: `1px solid  ${BLUE_EIGHT}`,
                                  display: "flex",
                                  textAlign: "center",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {t("text_choose_file")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
                </ReactDropzone>

                {file && (
                  <FormButton
                    title={t("text_upload")}
                    height={30}
                    width={"11vw"}
                    backgroundColor={BLUE_EIGHT}
                    titleColor={WHITE}
                    hoverTitleColor={BLUE_EIGHT}
                    hoverBackgroundColor={WHITE}
                    hoverBorderColor={BLUE_EIGHT}
                    onClickHandler={handleUpload}
                    style={{ fontSize: "0.8vw", fontWeight: "700" }}
                  />
                )}
              </div>
            </PreDialogOption>
          )}
        </div>

        <Typography variant="body2" className="pre-dialog-note">
          <ReportIcon className={classes.reportIcon} />
          {title === "Add Student"
            ? t(
                "text_If_you_don't_have_an_excel_file_to_store_student_data_you_can"
              )
            : t(
                "text_If_you_don't_have_an_excel_file_to_store_student_data_you_can"
              )}
          <a
            href={
              url
                ? url
                : title === t("text_add_student")
                ? csvStd
                : t("text_update_balance")
                ? csvBalance
                : csvInvoice
            }
            className={classes.predefindTemplateLink}
            download
          >
            {t("text_download_our_predefined_template")}
          </a>
        </Typography>
      </div>
    </Dialog>
  );
};

const PreDialogOption = ({ style, title, children, list }) => {
  const classes = preaddStyles();
  return (
    <div className={"dialog-component"} style={style}>
      <Typography className={classes.predialogTitle} variant="h6">
        {title}
      </Typography>

      <div className={classes.predialogChildern}>{children}</div>

      <div style={{ paddingTop: 10 }}>
        {list.map((item) => {
          return (
            <div className={classes.listContainer}>
              <RadioButtonUncheckedIcon className={classes.radioIcon} />
              <Typography variant="body2">{item}</Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
};
